import React, { useState } from 'react';
import ServiceInfo from './ServiceInfo';
import CasesList from './CasesList';
import Filter from './Filter';
const Services = () => {
    const [filter, setFilter] = useState(null);
    return (React.createElement("div", { className: "col-lg-12 no-pad" },
        React.createElement("div", { className: "page-heading" },
            React.createElement("h1", null, "Appearance Attorney Services and Fees")),
        React.createElement("div", { className: "col-lg-12 no-pad" },
            React.createElement("div", { className: "court-info" },
                React.createElement(Filter, { onSubmit: setFilter }),
                !filter && React.createElement(CasesList, null),
                filter && (React.createElement(ServiceInfo, { stateId: filter.stateId, serviceId: filter.serviceId }))))));
};
export default Services;
